function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RightToolbar from "@/components/RightToolbar/index.vue";
import { getTaskList, createTask, updateTask, deleteTask, getTaskDetail } from '@/api/task';
import { appletListApi } from '@/api/operation/applet';
import { getEnableQrcodeListApi } from "@/api/lotteryAssistant";
import { previewProductListApi } from "@/api/marketing/preview-product";
import { taskCodeOptions, taskTypeOptions, rewardTypeOptions } from '../enums';
var defaultFormData = {
  taskId: '',
  applicationId: '',
  applicationName: '',
  taskName: '',
  taskSubtitle: '',
  taskCode: '',
  taskType: '',
  taskUrl: '',
  popupId: '',
  dailyLimit: 1,
  rewardType: 1,
  rewardValue: 0,
  productIds: '',
  productList: [],
  browseDuration: 30,
  readCallback: 1,
  miniProgramAppId: '',
  miniProgramUrl: '',
  doubleRewardSwitch: 0,
  doubleRewardMultiple: 1,
  sort: 100,
  taskStatus: 0
};
export default {
  name: 'TaskDefinition',
  components: {
    RightToolbar: RightToolbar
  },
  data: function data() {
    return {
      // 遮罩层
      loading: false,
      statusOptions: [{
        label: '启用',
        value: 1,
        tag: 'green'
      }, {
        label: '禁用',
        value: 0,
        tag: 'red'
      }],
      taskCodeOptions: taskCodeOptions,
      taskTypeOptions: taskTypeOptions,
      rewardTypeOptions: rewardTypeOptions,
      readCbOptions: [{
        label: '默认回调',
        value: 1,
        disabled: false
      }, {
        label: '有效回调',
        value: 2,
        disabled: false
      }],
      appList: [],
      qrcodeList: [],
      previewProductList: [],
      // 表单校验
      rules: {
        applicationId: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择所属应用'
        }],
        taskName: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写任务名称'
        }],
        taskSubtitle: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写副标题'
        }],
        taskCode: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择任务编码'
        }],
        taskType: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择任务类型'
        }],
        popupId: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择客服'
        }],
        rewardType: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择奖励类型'
        }],
        rewardValue: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写奖励数值'
        }],
        dailyLimit: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写每日上限'
        }],
        productIds: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择商品'
        }],
        browseDuration: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请输入浏览时长'
        }],
        miniProgramAppId: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请输入小程序appid'
        }],
        miniProgramUrl: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请输入小程序路径'
        }],
        doubleRewardMultiple: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请输入浏览时长'
        }],
        sort: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请填写排序值'
        }],
        taskStatus: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择任务状态'
        }]
      },
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      editType: '',
      open: false,
      // 表单参数
      form: JSON.parse(JSON.stringify(defaultFormData))
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '任务名称',
        prop: 'taskName',
        defaultValue: '',
        type: 'input'
      }, {
        label: '任务状态',
        prop: 'taskStatus',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.statusOptions
        }
      }, {
        label: '所属应用',
        prop: 'applicationId',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.appList
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'taskId',
        visible: true,
        label: "\u4EFB\u52A1ID",
        width: 70
      }, {
        key: 'applicationName',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528",
        width: 90
      }, {
        key: 'taskName',
        visible: true,
        label: "\u4EFB\u52A1\u540D\u79F0",
        width: 160
      }, {
        key: 'taskSubtitle',
        visible: true,
        label: "\u526F\u6807\u9898",
        width: 160
      }, {
        key: 'taskCode',
        visible: true,
        label: "\u4EFB\u52A1\u7F16\u7801",
        width: 120,
        formatter: 'tag',
        formatOptions: {
          list: this.taskCodeOptions
        }
      }, {
        key: 'taskType',
        visible: true,
        label: "\u4EFB\u52A1\u7C7B\u578B",
        width: 100,
        formatter: 'text',
        formatOptions: {
          list: this.taskTypeOptions
        }
      }, {
        key: 'taskUrl',
        visible: true,
        label: "\u4EFB\u52A1\u94FE\u63A5",
        width: 160
      }, {
        key: 'dailyLimit',
        visible: true,
        label: "\u6BCF\u65E5\u9650\u5236/\u6240\u9700\u6B21\u6570",
        width: 160
      }, {
        key: 'rewardType',
        visible: true,
        label: "\u5956\u52B1\u7C7B\u578B",
        width: 100,
        formatter: 'text',
        formatOptions: {
          list: this.rewardTypeOptions
        }
      }, {
        key: 'rewardValue',
        visible: true,
        label: "\u6BCF\u6B21\u5956\u52B1\u6570\u503C",
        width: 100
      }, {
        key: 'sort',
        visible: true,
        label: "\u6392\u5E8F",
        width: 80
      }, {
        key: 'taskStatus',
        visible: true,
        label: "\u72B6\u6001",
        width: 80,
        formatter: 'tag',
        formatOptions: {
          list: this.statusOptions
        }
      }];
    }
  },
  created: function created() {
    this.getAppList();
    this.getQrcodeList();
    this.getPreviewProductList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      appletListApi(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    getQrcodeList: function getQrcodeList() {
      var _this2 = this;
      getEnableQrcodeListApi().then(function (data) {
        _this2.qrcodeList = data || [];
      });
    },
    getPreviewProductList: function getPreviewProductList() {
      var _this3 = this;
      var params = {
        page: 1,
        limit: 1000
      };
      previewProductListApi(params).then(function (data) {
        _this3.previewProductList = (data.list || []).map(function (item) {
          item.label = item.name;
          item.value = "".concat(item.id);
          return item;
        });
      });
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query) {
      var params = _objectSpread({}, query);
      return getTaskList(params);
    },
    /** 取消按钮 */cancel: function cancel() {
      this.editType = '';
      this.open = false;
    },
    /** 表单重置 */reset: function reset() {
      this.form = _objectSpread({}, defaultFormData);
      this.resetForm('form');
    },
    /** 新增按钮操作 */handleAdd: function handleAdd() {
      this.reset();
      this.editType = 'add';
      this.title = '添加任务';
      this.open = true;
    },
    /** 复制按钮操作 */handleCopy: function handleCopy(row) {
      var _this4 = this;
      getTaskDetail(row.taskId).then(function (data) {
        console.log(data);
        _this4.form = _objectSpread(_objectSpread({}, data), {}, {
          productList: data.productList || []
        });
        _this4.editType = 'copy';
        _this4.title = '复制任务';
        _this4.open = true;
      });
    },
    /** 修改按钮操作 */handleUpdate: function handleUpdate(row) {
      var _this5 = this;
      getTaskDetail(row.taskId).then(function (data) {
        _this5.form = _objectSpread(_objectSpread({}, data), {}, {
          productList: data.productList || []
        });
        _this5.editType = 'edit';
        _this5.title = '修改任务';
        _this5.open = true;
      });
    },
    changeApp: function changeApp(value) {
      var target = this.appList.find(function (item) {
        return item.value === value;
      });
      this.form.applicationName = (target === null || target === void 0 ? void 0 : target.appName) || '';
      this.form.appBelong = (target === null || target === void 0 ? void 0 : target.appName) || '';
    },
    changeTaskCode: function changeTaskCode(e) {
      var _this6 = this;
      if (this.form.taskCode === 'commission_task') {
        if (this.form.taskType === '4') {
          this.form.taskType = '';
          this.form.popupId = '';
        }
      }
      this.taskTypeOptions.forEach(function (item) {
        item.disabled = _this6.form.taskCode === 'commission_task' && item.value === '4';
      });
    },
    changeTaskType: function changeTaskType(e) {
      var _this7 = this;
      if (this.form.taskType !== '4') {
        this.form.popupId = '';
      }
      if (['5', '6'].includes(this.form.taskType)) {
        // 5、6 任务类型，禁用 红包、佣金
        this.form.rewardType = 1;
      }
      this.form.dailyLimit = this.form.taskType === '5' ? 180 : 1;
      this.rewardTypeOptions.forEach(function (item) {
        // 5、6 任务类型，禁用 红包、佣金
        item.disabled = ['5', '6'].includes(_this7.form.taskType) && [2, 3].includes(item.value);
      });
    },
    //快速添加
    handleSelectProduct: function handleSelectProduct() {
      var _this8 = this;
      this.$modalPreviewProductList(function (rows) {
        _this8.form.productList = rows.map(function (item) {
          return {
            productId: item.productId,
            productName: item.productName || item.name,
            productImage: item.productImage || item.image,
            productPrice: item.productPrice || item.price
          };
        });
        _this8.form.productIds = _this8.form.productList.map(function (item) {
          return item.productId;
        }).join(',');
        _this8.form.dailyLimit = _this8.form.productList.length;
      }, {
        multiple: true,
        limit: 8,
        isDefault: false,
        valueKey: 'productId',
        checked: this.form.productList
      });
    },
    handleRemove: function handleRemove(i) {
      this.form.productList.splice(i, 1);
      this.form.productIds = this.form.productList.map(function (item) {
        return item.productId;
      }).join(',');
      this.form.dailyLimit = this.form.productList.length;
    },
    /** 提交按钮 */submitForm: function submitForm() {
      var _this9 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (_this9.form.taskType === '6' && _this9.form.productList.length === 0) {
            return _this9.$message.warning('请选择商品');
          }
          _this9.loading = true;
          var params = _objectSpread(_objectSpread({}, _this9.form), {}, {
            taskId: _this9.editType === 'edit' ? _this9.form.taskId : undefined,
            productList: undefined
          });
          var func = _this9.editType === 'edit' ? updateTask : createTask;
          func(params).then(function (res) {
            _this9.loading = false;
            _this9.$message.success('保存成功');
            _this9.open = false;
            _this9.refreshList();
          }).catch(function (err) {
            _this9.loading = false;
            console.error('更新任务失败：', err);
            _this9.$message.error('保存失败');
          });
        }
      });
    },
    /** 删除按钮操作 */handleDelete: function handleDelete(row) {
      var _this10 = this;
      this.$modal.confirm('是否确认删除任务名称为"' + row.taskName + '"的数据项？').then(function () {
        return deleteTask(row.taskId);
      }).then(function () {
        _this10.$message.success('删除成功');
        _this10.refreshList();
      }).catch(function (err) {
        console.error('删除任务失败：', err);
        _this10.$message.error('删除任务失败');
      });
    }
  }
};